<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-form-item label="店铺名称">
        <el-input v-model="queryParams.shop_name" placeholder="请输入店铺名称" clearable size="small" />
      </el-form-item>
      <el-form-item label="店铺地址">
        <el-input v-model="queryParams.shop_address" placeholder="请输入店铺地址" clearable size="small" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="gap"></div>
    <div style="text-align: left; padding-left: 20px;">
      <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>
    </div>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="店铺序号" align="center" label-class-name='title' prop="id" />
      <el-table-column label="店铺名称" align="center" label-class-name='title' prop="shop_name" />
      <el-table-column label="店铺地址" align="center" label-class-name='title' prop="shop_address" />
      <el-table-column label="营业时间" align="center" label-class-name='title' prop="shop_time" />
      <el-table-column label="联系电话" align="center" label-class-name='title' prop="shop_phone" />
      <el-table-column label="店铺备注" align="center" label-class-name='title' prop="shop_remark" />
      <el-table-column label="店铺打印机" align="center" label-class-name='title' prop="shop_printNo" />
      <el-table-column label="经度" align="center" label-class-name='title' prop="lng" />
      <el-table-column label="纬度" align="center" label-class-name='title' prop="lat" />
      <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
            @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />

    <el-dialog :title="dialogTitle" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="店铺名称">
              <el-input v-model="form.shop_name" placeholder="请输入店铺名称" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="店铺地址">
              <el-input v-model="form.shop_address" placeholder="请输入店铺地址" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="经度">
              <el-input v-model="form.lng" placeholder="如 116.397428" clearable size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纬度" label-width="70px">
              <el-input v-model="form.lat" placeholder="如 39.90923" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="营业时间">
              <el-input v-model="form.shop_time" placeholder="请输入营业时间" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="联系电话">
              <el-input v-model="form.shop_phone" placeholder="请输入联系电话" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="店铺备注">
              <el-input v-model="form.shop_remark" placeholder="请输入店铺备注" clearable size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="店铺打印机">
              <el-select style="width: 100%;" v-model="form.shop_printNo" placeholder="请选择打印机" clearable>
                <el-option v-for="item in printNoList" :key="item.id" :label="item.print_name"
                  :value="item.print_name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { shopAdd, shopList, shopDelete, shopUpdate } from '../api/shop/index'
import { printNoList } from '../api/printNo/index'
export default {
  name: 'Shop',
  data () {
    return {
      list: [],
      printNoList: [],
      form: {},
      open: false,
      dialogTitle: '店铺新增',
      pageIndex: 1,
      pageSize: 10,
      queryParams: {},
      loading: false,
      total: 0
    }
  },

  created () {
    let flag = sessionStorage.getItem('login')
    if (!flag) {
      this.$router.push('/')
    }
    this.getPrintNoList()
    this.handleQuery()
  },
  methods: {
    //  获取打印机列表（下拉选择）
    getPrintNoList () {
      printNoList({ pageIndex: 1, pageSize: 9999 }).then(res => {
        this.printNoList = res.data.list || []
      })
    },
    handleUpdate (row) {
      this.open = true
      this.dialogTitle = '店铺修改'
      this.form = row
    },
    handleDelete (row) {
      let params = {
        id: row.id
      }

      this.$confirm('确认删除吗？')
        .then(() => {
          shopDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => {})
    },
    submit () {
      debugger
      let params = this.form
      if (!params.shop_name) {
        return this.$message.error('请输入店铺名称')
      }
      if (params.lng && isNaN(Number(params.lng))) {
        return this.$message.error('经度必须为数字')
      }
      if (params.lat && isNaN(Number(params.lat))) {
        return this.$message.error('纬度必须为数字')
      }
      if (!params.id) {
        shopAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        shopUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          this.open = false
          this.handleQuery()
        })
      }
    },

    handleAdd () {
      this.open = true
      this.dialogTitle = '店铺新增'
      this.form = {}
    },
    handleQuery () {
      let params = this.queryParams
      params.pageIndex = this.pageIndex
      params.pageSize = this.pageSize

      this.list = []
      shopList(params).then(res => {
        this.list = res.data.list
        this.total = res.data.total
      })
    },
    resetQuery () {
      this.queryParams = {
        shop_name: '',
        shop_address: ''
      }
      this.pageIndex = 1
      this.handleQuery()
    },
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      shopList(params).then(res => {
        this.list = res.data.list
        this.total = res.data.total
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/views/shop.vue